/**
 * Mobile "Table of contents" collapse/expand toggle.
 *
 * @return {void}
 */
export const initTocToggle = () => {

	const toggle = document.querySelector( '.js-toc-toggle' );

	if ( ! toggle ) {

		return;

	}

	const panel = document.getElementById( toggle.getAttribute( 'aria-controls' ) );

	if ( ! panel ) {

		return;

	}

	toggle.addEventListener( 'click', () => {

		const isExpanded = toggle.getAttribute( 'aria-expanded' ) === 'true';

		toggle.setAttribute( 'aria-expanded', String( ! isExpanded ) );
		panel.hidden = isExpanded;

	} );

};
